import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { BookingQuestion } from './booking-types.types'

export const USE_GET_BOOKING_QUESTIONS_QUERY_KEY = 'useGetBookingQuestions'

export const getBookingQuestions = async (signal?: AbortSignal) => {
  const response = await authAPI.get<BookingQuestion[]>('/question', { signal })
  return response.data
}

export const useGetBookingQuestions = () => {
  return useQuery({
    queryFn: ({ signal }) => getBookingQuestions(signal),
    queryKey: [USE_GET_BOOKING_QUESTIONS_QUERY_KEY],
  })
}

export const useInvalidateBookingQuestions = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_BOOKING_QUESTIONS_QUERY_KEY] })
}
